<template>
    <div
      v-if="s.popup == 'areYouSure'"
      id="popnew"
      class="max-w-[500px] max-h-[260px] p-5 bg-white fixed left-1/2 -translate-x-1/2 z-20 rounded-lg top-1/4 bottom-4 overflow-hidden max-l:w-11/12 max-l:max-w-11/12"
    >
      <h1 class="font-latobold text-xl text-center mb-3 no-select">
        Подтвердите действие
      </h1>
      <p class="text-base text-center no-select">
        Вы собираетесь удалить <b>ЛИДы в количестве {{ checked.length }} шт. </b>
        <br />Вместе с ними будут удалены все связанные с этим ЛИДами задачи,
        заявки и их задачи, счета и их задачи, заказы и их задачи!
      </p>
      <p class="text-base text-center my-3 no-select">
        <b>Данное действие является необратимым</b>
      </p>
      <!-- <p class="text-base text-center no-select">
        Для удаления введите код "<span class="text-xl text-rose-500"
          ><strong>удалить лид</strong></span
        >" в текстовое поле ниже, чтобы продолжить
      </p> -->
  
      <div class="flex justify-center items-center mt-4">
        <!-- <input
          v-model="specialWord"
          type="text"
          class="h-9 px-3 py-2 text-sm bg-slate-50"
          placeholder="Кодовое слово"
        /> -->
        <button
          class="bg-rose-500 px-8 v-btn duration-100 transition ease-linear text-white"
          @click="MassActionClick()"
        >
          Удалить
        </button>
      </div>
    </div>
    <div
      v-if="s.popup"
      @click="close"
      id="overlay"
      class="fixed bg-cyan-900 z-2 w-screen h-screen top-0 left-0 opacity-80"
    ></div>
  
    <div
      class="mb-9 mt-4 grid grid-cols-order__top place-content-center gap-x-14px gap-y-24px"
    >
      <div
        class="relative cursor-pointer text-center uppercase group w-28 h-28 m-auto transition-all duration-300 ease-in-out"
        @click="filterStatus(1)"
      >
        <div
          class="overflow-hidden w-full h-full transition duration-300 ease-in-out"
        >
          <svg
            class="z-2 relative mt-5 w-5 h-5 fill-white mx-auto group-hover:w-6 group-hover:h-6 transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#status-1"></use>
          </svg>
          <h2
            class="text-2xl z-2 relative mt-1 text-white group-hover:text-3xl transition-all duration-300"
            v-if="LeadCounter"
          >
            {{ LeadCounter[1] }}
          </h2>
          <svg
            class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 fill-status-1 group-hover:w-full group-hover:h-full transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#bg-romb"></use>
          </svg>
        </div>
        <span
          class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-4 opacity-100 text-status-20 font-latobold"
          >Новый</span
        >
      </div>
  
      <div
        class="relative cursor-pointer text-center uppercase group w-28 h-28 m-auto transition-all duration-300 ease-in-out"
        @click="filterStatus(2)"
      >
        <div
          class="overflow-hidden w-full h-full transition duration-300 ease-in-out"
        >
          <svg
            class="z-2 relative mt-5 w-5 h-5 fill-white mx-auto group-hover:w-6 group-hover:h-6 transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#nav-masters"></use>
          </svg>
          <h2
            class="text-2xl z-2 relative mt-1 text-white group-hover:text-3xl transition-all duration-300"
            v-if="LeadCounter"
          >
            {{ LeadCounter[2] }}
          </h2>
          <svg
            class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 fill-status-2 group-hover:w-full group-hover:h-full transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#bg-romb"></use>
          </svg>
        </div>
        <span
          class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-4 opacity-100 text-status-20 font-latobold "
          >В работе</span
        >
      </div>

      <div
        class="relative cursor-pointer text-center uppercase group w-28 h-28 m-auto transition-all duration-300 ease-in-out"
        @click="filterStatus(5)"
      >
        <div
          class="overflow-hidden w-full h-full transition duration-300 ease-in-out"
        >
          <svg
            class="z-2 relative mt-5 w-5 h-5 fill-white mx-auto group-hover:w-6 group-hover:h-6 transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#status-8"></use>
          </svg>
          <h2
            class="text-2xl z-2 relative mt-1 text-white group-hover:text-3xl transition-all duration-300"
            v-if="LeadCounter"
          >
            {{ LeadCounter[5] }}
          </h2>
          <svg
            class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 fill-[#22C55E] group-hover:w-full group-hover:h-full transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#bg-romb"></use>
          </svg>
        </div>
        <span
          class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-4 opacity-100 text-status-20 font-latobold bottom-[-35px]"
          >ОПЛАТИЛ КЛИЕНТ</span
        >
      </div>
  
      <div
        class="relative cursor-pointer text-center uppercase group w-28 h-28 m-auto transition-all duration-300 ease-in-out"
        @click="filterStatus(4)"
      >
        <div
          class="overflow-hidden w-full h-full transition duration-300 ease-in-out"
        >
          <svg
            class="z-2 relative mt-5 w-5 h-5 fill-white mx-auto group-hover:w-6 group-hover:h-6 transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#ico-ok"></use>
          </svg>
          <h2
            class="text-2xl z-2 relative mt-1 text-white group-hover:text-3xl transition-all duration-300"
            v-if="LeadCounter"
          >
            {{ LeadCounter[4] }}
          </h2>
          <svg
            class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 fill-status-6 group-hover:w-full group-hover:h-full transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#bg-romb"></use>
          </svg>
        </div>
        <span
          class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-4 opacity-100 text-status-20 font-latobold"
          >Выполнен</span
        >
      </div>

      <div
        class="relative cursor-pointer text-center uppercase group w-28 h-28 m-auto transition-all duration-300 ease-in-out"
        @click="filterStatus(3)"
      >
        <div
          class="overflow-hidden w-full h-full transition duration-300 ease-in-out"
        >
          <svg
            class="z-2 relative mt-5 w-5 h-5 fill-white mx-auto group-hover:w-6 group-hover:h-6 transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#status-11"></use>
          </svg>
          <h2
            class="text-2xl z-2 relative mt-1 text-white group-hover:text-3xl transition-all duration-300"
            v-if="LeadCounter"
          >
            {{ LeadCounter[3] }}
          </h2>
          <svg
            class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 fill-status-11 group-hover:w-full group-hover:h-full transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#bg-romb"></use>
          </svg>
        </div>
        <span
          class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-4 opacity-100 text-status-20 font-latobold"
          >Отказ</span
        >
      </div>


      <!-- <div
        class="relative cursor-pointer text-center uppercase group w-28 h-28 m-auto transition-all duration-300 ease-in-out"
        @click="filterStatus(6)"
      >
        <div
          class="overflow-hidden w-full h-full transition duration-300 ease-in-out"
        >
          <svg
            class="z-2 relative mt-5 w-5 h-5 fill-white mx-auto group-hover:w-6 group-hover:h-6 transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#status-10"></use>
          </svg>
          <h2
            class="text-2xl z-2 relative mt-1 text-white group-hover:text-3xl transition-all duration-300"
            v-if="LeadCounter"
          >
            {{ LeadCounter[6] }}
          </h2>
          <svg
            class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 fill-status-14 group-hover:w-full group-hover:h-full transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#bg-romb"></use>
          </svg>
        </div>
        <span
          class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-4 opacity-100 text-status-20 font-latobold "
          >АРХИВ</span
        >
      </div> -->

    </div>
  
    <div class="pb-4 w-full flex flex-wrap items-center">
      <h2
        class="mr-15px h-9 min-w-[2.25rem] border border-teal-700 rounded-lg p-2 text-center my-4"
      >
        <span class="w-full text-lg leading-none text-teal-700">
          {{ this.LeadList?.length }}
        </span>
      </h2>
      <p class="mr-2 text-gray-400">С</p>
      <input
        class="h-9 px-3 my-2 text-sm bg-slate-50 outline-none min-w-[9rem] w-[9rem] mr-4"
        type="date"
        v-model="s.start"
        @change="findLead1(s)"
      />
      <p class="mr-2 text-gray-400">По</p>
      <input
        class="h-9 px-3 my-2 text-sm bg-slate-50 outline-none min-w-[9rem] w-[9rem] mr-4"
        type="date"
        v-model="s.end"
        @change="findLead1(s)"
      />
  
      <div class="flex-2_0 mr-15px w-[200px] my-4">
        <input
          type="text"
          class="h-9 w-[100%] px-3 py-2 text-sm bg-slate-50"
          placeholder="Название"
          v-model="s.findme"
          @input="findLead1(s)"
        />
      </div>

      <template
        v-if="['Manager', 'Logist', 'Studio', 'Hosd', 'Check'].includes(role)"
      >
        <select
          class="my-2 h-9 min-w-[11rem] w-[11rem] mr-4 px-3 bg-slate-50"
          @change="findLead1(s)"
          v-model="s.manager"
        >
          <option disabled="true" value="">Менеджер</option>
          <template v-for="m in selectManagers" :key="m">
            <option :value="m.uid">{{ m.secondname }} {{ m.name }}</option>
          </template>
        </select>
      </template>
  
      <template
        v-if="['Manager', 'Logist', 'Studio', 'Hosd', 'Check'].includes(role)"
      >
        <select
          class="my-2 h-9 min-w-[11rem] w-[11rem] mr-4 px-3 bg-slate-50"
          @change="findLead1(s)"
          v-model="s.creator"
        >
          <option disabled="true" value="">Создатель</option>
          <option value="1">Робот</option>
          <template v-for="m in selectManagers" :key="m">
            <option :value="m.uid">{{ m.secondname }} {{ m.name }}</option>
          </template>
        </select>
      </template>
  
      <div class="flex py-4">
        <button class="v-btn bg-gray-500 hover:bg-gray-400 mr-4" v-if="s.clear">
          <span class="v-btn_text" @click="Clear">Сброс</span>
        </button>
        <!-- <template v-if="['Manager', 'Logist', 'Studio', 'Hosd', 'Check'].includes(role)">
                  <button class="v-btn bg-green-500 hover:bg-green-400">
                      <span class="v-btn_text flex items-center" @click="addLead(null)">
                          <svg class="fill-white w-16px h-16px mr-3 rotate-45 group-hover:-rotate-45 duration-100 transition ease-linear">
                              <use xlink:href="@/assets/i.svg#ico-no"></use>
                          </svg>
                          Создать
                      </span>
                  </button>
              </template> -->
      </div>
    </div>
  
    <div class="flex items-center">
      <select
        class="mb-4"
        v-model="leadPaginator.itemsInPage"
        style="padding: 7px"
      >
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="50">50</option>
        <option value="100">100</option>
      </select>
      <Paginator :count="pageCount" v-model="leadPaginator.page" />
      <div class="flex items-center mx-4 mb-4" v-if="checked?.length">
        С отмеченными ({{ checked.length }})
        <select v-model="action" class="my-2 mx-2 h-9 w-44 mr-4 bg-slate-50">
          <option value="">Ничего</option>
          <option value="del">Удалить</option>
        </select>
        <button
          :disabled="!action"
          @click="s.popup = 'areYouSure'"
          :class="{ 'bg-rose-500': action, 'bg-rose-300': !action }"
          class="mr-15px v-btn duration-100 transition ease-linear text-white"
        >
          Выполнить
        </button>
        <button
          class="v-btn duration-100 transition ease-linear bg-orange-400"
          @click="
            action = '';
            checked = [];
          "
        >
          Сбросить
        </button>
      </div>
    </div>
  
    <div
      v-if="LeadList?.length > 0"
      class="w-full bg-white v-bgray2 mb-8 overflow-hidden rounded-xl relative overflow-x-auto"
    >
      <div class="grid grid-cols-15 h-10 v-bbgray px-4 uppercase items-center">
        <div
          class="flex font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px]"
        >
          <input
            v-if="['Studio', 'Hosd', 'Director'].includes(role)"
            class="mr-2"
            type="checkbox"
            @change="SelectAllPage()"
            v-model="massCheckValue"
          />
          <p>№</p>
        </div>
  
        <div
          class="ml-4 font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px] col-span-1"
        >
          ДАТА СОЗДАНИЯ
        </div>
        <div
          class="ml-16 font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px] col-span-3"
        >
          Клиент
        </div>
        <div
          class="ml-2 font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px] col-span-2"
        >
          МЕНЕДЖЕР
        </div>
        
        <div
          class="ml-2 font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px] col-span-2"
        >
          <!-- СУММА НАЧИСЛЕНА -->
        </div>
        <div
          class="ml-2 font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px] col-span-2"
        >
          <!-- СУММА ВЫПЛАЧЕНА -->
        </div>
        <div
          class="ml-2 font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px] col-span-2"
        >
          СУММА К ВЫПЛАТЕ
        </div>
      </div>
      <template v-for="item in PaginatedLeadList" :key="item">
        <a
          class="grid grid-cols-15 px-4 py-2 gap-2 v-bbgray bg-teal-light odd:bg-white items-center transition duration-300 cursor-pointer hover:shadow-v1 max-2xl:grid-cols-order_m max-2xl:auto-rows-[50px]"
          :class="'status-' + item.status"
        >
          <div class="flex w-28">
            <div
              v-if="['Studio', 'Hosd', 'Director'].includes(role)"
              class="cell w5 mr-2"
            >
              <input
                v-if="CanBeChecked(item)"
                type="checkbox"
                :value="item.id"
                v-model="checked"
              />
            </div>
            #{{ item.lead_id }}
          </div>
  
          <div @click="()=>getOne(item.lead_id)" class="items-center">
            <div class="flex items-center ml-2">
              <svg class="fill-gray-400 w-2 h-2 mr-1 rotate-45">
                <use xlink:href="@/assets/i.svg#ico-no"></use>
              </svg>
              <div class="text-gray-400 text-xs">
                {{ moment(item.create_at).format("DD.MM.YYYY") }}
              </div>
            </div>
          </div>
  
          <div
            @click="()=>getOne(item.lead_id)"
            class="text-black flex w-full h-full items-center col-span-3"
          >
            <span
              class="text-white w-11 h-11 mr-4 text-xl leading-none rounded-full flex items-center justify-center min-w-[44px]"
              :class="'bg-status-' + item.status"
            >
              {{ item.cname?.slice(0, 1) }}
            </span>
            <div class="flex flex-col justify-center overflow-hidden pr-4">
              <span
                class="text-base font-semibold break-all max-h-10 leading-5"
                >{{ item.cname }}</span
              >
            </div>
          </div>
          <div
            @click="()=>getOne(item.lead_id)"
            v-if="item.mname"
            class="font-latoblod-serif font-[16px] text-v-gray relative flex justify-start items-center col-span-2 max-m:col-span-2"
          >
            <div
              class="min-w-[1.5rem] rounded-full mr-3 overflow-hidden"
              :class="'bg-status-' + item.status"
            >
              <IcoPic :pic="item.mpicture" :name="item.mname" />
            </div>
            <div class="flex flex-col justify-center overflow-hidden">
              <span class="text-[10px] text-gray-400 leading-none uppercase"
                >Менеджер</span
              >
              <span class="text-black overflow-hidden">{{ item.mname }}</span>
            </div>
          </div>
          <div
            @click="()=>getOne(item.lead_id)"
            v-else
            class="flex justify-start items-center col-span-2 max-m:col-span-2"
          >
            <span
              class="w-11 h-11 bg-slate-200 flex justify-center rounded-full items-center overflow-hidden mr-2"
            >
              <svg class="w-4 h-4 fill-white">
                <use xlink:href="@/assets/i.svg#ico-avatar"></use>
              </svg>
            </span>
          </div>
          <div
            @click="()=>getOne(item.lead_id)"
            class="flex flex-col col-span-2 text-black text-xs tex-left max-h-16"
          >
             <!-- {{ item.agent_sum != null? item.agent_sum + ' ₽': '0 ₽'}}   -->
          </div>
          <div
            @click="()=>getOne(item.lead_id)"
            class="flex flex-col text-black col-span-2 text-xs tex-left max-h-16"
          >
             <!-- {{ item.agent_status == 2 && item.agent_sum != null? item.agent_sum + ' ₽' : '0 ₽' }}   -->
          </div>
  
          <div
            @click="()=>getOne(item.lead_id)"
            class="flex flex-col text-black text-xs tex-left max-h-16"
          >
            {{ item.agent_sum != null && (item.lead_status != 11 && item.bid_status != 4 && item.invoice_status != 4 && item.order_status != 11) && (item.invoice_status == 3 && item.order_status == 8)? item.agent_sum + ' ₽': '0 ₽'}}  
             <!-- {{ item.agent_date == null? 'дата не указана':  new Date (item.agent_date).toLocaleString('ru-Ru') }}   -->
          </div>
        </a>
      </template>
    </div>
    <div v-else-if="s.loader" class="absolute top-60 left-0 flex-cc w-full">
      <img src="https://api.tahocrm.ru/images/loader.svg" />
    </div>
    <div
      v-else
      class="top-60 left-0 flex-cc w-full text-slate-300 text-2xl text-center"
    >
      Нет данных
    </div>
  <div class="flex flex-row justify-around bg-white rounded-sm py-2 px-1 relative">
    <div class="font-semibold text-base text-black w-[25%] flex justify-between">
      <p>Сумма:</p>
      <p class="mr-4">{{ summa }} ₽</p>
    </div>
    <div class="font-semibold text-base text-black w-[25%] flex justify-between">
      <p>Начислено:</p>
      <p class="mr-4">{{ nachisleno }} ₽</p>
    </div>
    <div class="font-semibold text-base text-black w-[25%] flex justify-between">
      <p>К выплате:</p>
      <p class="mr-4">{{ kViplate }} ₽</p>
    </div>
    <div class="font-semibold text-base text-black w-[25%] flex justify-between">
      <!-- <p>Всего выплачено:</p>
      <p class="mr-4">0 ₽</p> -->
    </div>
  </div>
  <div v-if="canShowGar" @click="canShowGar = false" class="fixed bg-cyan-800 z-10 w-full h-full top-0 left-0 opacity-80"> 
  </div>
  <div
  v-if="canShowGar"
  class="w-8/12 bg-slate-200 fixed left-1/2 -translate-x-1/2 z-20 rounded-lg top-[30%] bottom-[30%] max-h-screen overflow-y-auto overflow-hidden max-l:w-11/12 max-l:max-w-11/12"
  >
  <div
      class="flex justify-between border-t-2 border-gray-400 w-[90%] mt-10 mb-1 mx-auto max-m:hidden "
    >
      <div class="flex flex-col items-center -mt-6 -ml-6 relative">
        <span
          class="rounded-full h-11 w-11 bg-green-500 flex items-center justify-center"
        >
          <svg class="w-5 h-5 fill-white">
            <use xlink:href="@/assets/i.svg#nav-clients"></use>
          </svg>
        </span>
        <span
          class="text-[10px] text-gray-400 leading-none uppercase mt-1"
          >КАСАНИЕ</span
        >
      </div>
      <div class="flex flex-col items-center -mt-6 relative">
        <span
          class="rounded-full h-11 w-11 bg-gray-400 flex items-center justify-center"
          :class="{
            '!bg-[#22C55E]': lead?.leads[0]?.status != 1 && lead?.leads[0]?.cancel_id == null && lead?.leads.length !=0,
            '!bg-[#F4487E]': lead?.leads[0]?.status == 11,
            '!bg-[#42B6F8]': lead?.leads[0]?.status == 1
          }"
        >
          <svg class="w-5 h-5 fill-white">
            <use xlink:href="@/assets/i.svg#status-1"></use>
          </svg>
        </span>
        <span
          class="text-[10px] text-gray-400 leading-none uppercase mt-1"
          >ЛИД</span
        >
      </div>
      <div class="flex flex-col items-center -mt-6 relative">
        <span
          class="rounded-full h-11 w-11 flex items-center justify-center bg-gray-400"
          :class="{
            '!bg-[#22C55E]': lead?.bids[0]?.status != 1 && lead?.bids[0]?.cancel_id == null && lead?.bids.length !=0,
            '!bg-[#F4487E]': lead?.bids[0]?.status == 4,
            '!bg-[#42B6F8]': lead?.bids[0]?.status == 1
          }"
        >
          <svg class="w-5 h-5 fill-white">
            <use xlink:href="@/assets/i.svg#doc"></use>
          </svg>
        </span>
        <span
          class="text-[10px] text-gray-400 leading-none uppercase mt-1"
          >ЗАЯВКА</span
        >
      </div>
      <div class="flex flex-col items-center -mt-6 relative">
        <span
          class="rounded-full h-11 w-11 flex items-center justify-center bg-gray-400"
          :class="{
            '!bg-[#22C55E]': lead?.invoices[0]?.status != 1 && lead?.invoices[0]?.cancel_id == null && lead?.invoices.length !=0,
            '!bg-[#F4487E]': lead?.invoices[0]?.status == 4,
            '!bg-[#42B6F8]': lead?.invoices[0]?.status == 1
          }"
        >
          <svg class="w-5 h-5 fill-white">
            <use xlink:href="@/assets/i.svg#doc"></use>
          </svg>
        </span>
        <span
          class="text-[10px] text-gray-400 leading-none uppercase mt-1"
          >СЧЕТ</span
        >
      </div>
      <div class="flex flex-col items-center -mt-6 relative">
        <span
          class="rounded-full h-11 w-11 flex items-center justify-center bg-gray-400"
          :class="{
            '!bg-[#22C55E]': lead?.orders[0]?.status != 1 && lead?.orders[0]?.cancel_id == null && lead?.orders.length !=0,
            '!bg-[#F4487E]': lead?.orders[0]?.status == 11,
            '!bg-[#42B6F8]': lead?.orders[0]?.status == 1
          }"
        >
          <svg class="w-5 h-5 fill-white">
            <use xlink:href="@/assets/i.svg#pay-1"></use>
          </svg>
        </span>
        <span
          class="text-[10px] text-gray-400 leading-none uppercase mt-1"
          >ЗАКАЗ</span
        >
      </div>
  </div>
  <div class="mt-10 flex flex-col items-center justify-center">
    <p v-if="lead?.leads[0]?.cancel_id != null" class="text-[#F4487E] w-[100%] text-center font-bold mt-4 ">ОТКАЗ НА УРОВНЕ ЛИДА</p>
    <p v-if="lead?.bids[0]?.cancel_id != null" class="text-[#F4487E] w-[100%] text-center font-bold mt-4 ">ОТКАЗ НА УРОВНЕ ЗАЯВКИ</p>
    <p v-if="lead?.invoices[0]?.cancel_id != null" class="text-[#F4487E] w-[100%] text-center font-bold mt-4 ">ОТКАЗ НА УРОВНЕ СЧЕТА</p>
    <p v-if="lead?.orders[0]?.cancel_id != null" class="text-[#F4487E] w-[100%] text-center font-bold mt-4 ">ОТКАЗ НА УРОВНЕ ЗАКАЗА</p>

    <p v-if="lead?.leads[0]?.cancel_id != null" class="text-[#F4487E] w-[100%] text-center font-bold mt-4 ">ПРИЧИНА: <br>{{ this.cancel_Lead[lead?.leads[0]?.cancel_id] }}</p>
    <p v-if="lead?.bids[0]?.cancel_id != null" class="text-[#F4487E] w-[100%] text-center font-bold mt-4 ">ПРИЧИНА: <br>{{ this.cancel_Bid[lead?.bids[0]?.cancel_id] }}</p>
    <p v-if="lead?.invoices[0]?.cancel_id != null" class="text-[#F4487E] w-[100%] text-center font-bold mt-4 ">ПРИЧИНА: <br>{{ this.cancel_Invoice[lead?.invoices[0]?.cancel_id] }}</p>
    <p v-if="lead?.orders[0]?.cancel_id != null" class="text-[#F4487E] w-[100%] text-center font-bold mt-4 ">ПРИЧИНА: <br>{{ this.cancel_Order[lead?.orders[0]?.cancel_id] }}</p>

    <p v-if="lead?.leads[0]?.cancel_id != null" class="text-[#F4487E] w-[100%] text-center font-bold mt-4 ">КОММЕНТАРИЙ: <br>{{ lead?.leads[0]?.comment }}</p>
    <p v-if="lead?.bids[0]?.cancel_id != null" class="text-[#F4487E] w-[100%] text-center font-bold mt-4 ">КОММЕНТАРИЙ: <br>{{ lead?.bids[0]?.comment }}</p>
    <p v-if="lead?.invoices[0]?.cancel_id != null" class="text-[#F4487E] w-[100%] text-center font-bold mt-4 ">КОММЕНТАРИЙ: <br>{{ lead?.invoices[0]?.comment }}</p>
    <p v-if="lead?.orders[0]?.cancel_id != null" class="text-[#F4487E] w-[100%] text-center font-bold mt-4 ">КОММЕНТАРИЙ: <br>{{ lead?.orders[0]?.comment }}</p>
  </div>
  </div>
  </template>
  
  <script>
  import { mapActions, mapGetters } from "vuex";
  import moment from "moment";
  // import LineIco from "../components/ui/LineIco.vue";
  import Paginator from "@/components/ui/Paginator";
  
  export default {
    name: "LeadList",
  
    components: {
      // LineIco
      Paginator,
    },
  
    data() {
      return {
        moment: moment,
        checked: [],
        specialWord: "",
        massCheckValue: false,
        action: "",
        canShowGar: false,
        direction: { 1: "ВХОДЯЩИЙ", 2: "ИСХОДЯЩИЙ" },
        type: { 1: "ПЕРВИЧНЫЙ", 2: "ВТОРИЧНЫЙ" },
        detail: {
          101: 'Задача "Как дела"',
          102: 'Задача "Пролонгация"',
          103: "Контроль качества",
          104: "Агент-сотрудник",
        },
        channel: {
          1: "Интернет",
          2: "Рекомендация",
          3: "Агент",
          4: "Обзвон новой базы",
          15: "Обзвон новой базы",
          21: "Вторичная клиентская база",
          22: "Рассылка",
          23: "Агент-сотрудник",
          31: "Вторичная клиентская база",
        },
        cancel_Lead: {
          101: "Нецелевой ЛИД: другой регион",
          102: "Нецелевой ЛИД: б/у оборудование",
          103: "Нецелевой ЛИД: экономически нецелесообразно",
          104: "Нецелевой ЛИД: карты тахографа",
          105: "Нецелевой ЛИД: консультация",
          106: "Нецелевой ЛИД: недозвон",
          201: "Целевой ЛИД: дорого",
          202: "Целевой ЛИД: другое",
        },
        cancel_Bid: {
          101: "Нецелевая Заявка: другой регион",
          102: "Нецелевая Заявка: б/у оборудование",
          103: "Нецелевая Заявка: экономически нецелесообразно",
          104: "Нецелевая Заявка: карты тахографа",
          105: "Нецелевая Заявка: консультация",
          106: "Нецелевая Заявка: недозвон",
          201: "Целевая Заявка: дорого",
          202: "Целевая Заявка: другое",
        },
        cancel_Invoice: {
          101: "Нецелевой Счет: другой регион",
          102: "Нецелевой Счет: б/у оборудование",
          103: "Нецелевой Счет: экономически нецелесообразно",
          104: "Нецелевой Счет: карты тахографа",
          105: "Нецелевой Счет: консультация",
          106: "Нецелевой Счет: недозвон",
          201: "Целевой Счет: дорого",
          202: "Целевой Счет: другое",
        },
        cancel_Order: {
          101: "Нецелевой Заказ: другой регион",
          102: "Нецелевой Заказ: б/у оборудование",
          103: "Нецелевой Заказ: экономически нецелесообразно",
          104: "Нецелевой Заказ: карты тахографа",
          105: "Нецелевой Заказ: консультация",
          106: "Нецелевой Заказ: недозвон",
          201: "Целевой Заказ: дорого",
          202: "Целевой Заказ: другое",
        },
      };
    },
  
    computed: {
      ...mapGetters([
        "s",
        "profile",
        "role",
        "roles",
        "LeadList",
        "LeadCounter",
        "countLeads",
        "selectManagers",
        "selectMasters",
        "leadPaginator",
        "lead",
        "summa",
        "nachisleno",
        "kViplate"
      ]),
      page() {
        return this.leadPaginator.page;
      },
      itemsInPage() {
        return this.leadPaginator.itemsInPage;
      },
      pageCount() {
        return Math.ceil((this.LeadList?.length ?? 0) / this.itemsInPage);
      },
      PaginatedLeadList() {
        return this.LeadList.slice(
          this.page * this.itemsInPage,
          (this.page + 1) * this.itemsInPage
        );
      },
      sumLead() {
        let sum = 0;
        for (let i = 0; i < this.LeadList.length; i++) {
          sum += this.LeadList[i].sum;
        }
        return this.addSpace(sum);
      },
      sumMarge() {
        let margin = 0;
        for (let i = 0; i < this.LeadList.length; i++) {
          margin += this.LeadList[i].sum;
        }
        margin = Math.round(margin*0.33)
        return this.addSpace(margin);
      },
    },
  
    methods: {
      ...mapActions([
        "RemoveSelectedLeads",
        "getLeads",
        "addLead",
        "setLead",
        "showLead",
        "findLead1",
        "statusLead",
        "find",
        "setSettings",
        "clearSettings",
        "fillLeads",
        'getLead'
      ]),
  
      CanBeChecked(item) {
        if (this.$store.state.profile.role == "Studio") return true;
        if (this.$store.state.profile.role == "Manager")
          return item?.manager_id == this.$store.state.profile.profile.id;
        return false;
      },
  
      SelectAllPage() {
        console.log(this.massCheckValue);
        if (this.massCheckValue) {
          this.checked.push(...this.PaginatedLeadList.map(({ id }) => id));
        } else {
          let ids = new Set(this.PaginatedLeadList.map(({ id }) => id));
          this.checked = this.checked.filter((id) => !ids.has(id));
        }
      },
  
      addSpace(strNumber) {
        return String(strNumber).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1 ");
      },
  
      async MassActionClick() {
        switch (this.action) {
          case "del":
            // if (this.specialWord.toLowerCase() == "удалить лид") {
            await this.RemoveSelectedLeads({ checked: this.checked });
  
            this.checked = [];
            this.action = "";
            this.specialWord = "";
            this.s.popup = null;
  
            this.massCheckValue = false;
            return true;
          // } else {
          //   alert("Код введен неверно, удаление не будет произведено!");
          //   this.specialWord = "";
          // }
        }
      },
  
      close() {
        this.s.popup = null;
        this.specialWord = "";
      },
  
      filterStatus(status) {
        this.s.status = status;
        this.s.claim = "";
        this.s.doc = "";
        this.setSettings(this.s);
        this.statusLead(this.s);
      },
  
      filterPayStatus() {
        this.s.pay_status = 1;
        this.findLead1(this.s);
      },
  
      filterClaim() {
        this.s.status = "";
        this.s.claim = 1;
        this.setSettings(this.s);
        this.statusLead(this.s);
      },
  
      filterDoc() {
        this.s.status = "";
        this.s.doc = 1;
        this.setSettings(this.s);
        this.statusLead(this.s);
      },
  
      filterTrans() {
        this.s.status = "";
        this.s.trans = 1;
        this.setSettings(this.s);
        this.statusLead(this.s);
      },
  
      filterPay(pay) {
        this.s.pay = pay;
        this.setSettings(this.s);
        this.findLead1(this.s);
      },
  
      filterCategory(category) {
        this.s.category = category;
        this.setSettings(this.s);
        this.findLead1(this.s);
      },
  
      Clear() {
        this.s.status = "";
        this.s.doc = "";
        this.s.claim = "";
        this.s.doc = "";
        this.clearSettings();
        this.fillLeads();
        this.getLeads();
      },
      getOne(id){
      this.canShowGar = true
      this.getLead(id)
    },

    },
    mounted() {
      this.getLeads();
    },
  };
  </script>
  
  <style>
  .bg-status-8 {
    --tw-bg-opacity: 1;
    background-color: rgb(255 72 126 / var(--tw-bg-opacity));
  }
  </style>
  
  <style scoped>
  .grid-cols-15 {
    grid-template-columns: 70px repeat(12, minmax(0, 1fr)) !important;
  }
  .no-select {
    -webkit-user-select: none; /* Chrome/Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE/Edge */
    user-select: none; /* Стандартный синтаксис */
  }
  </style>